export enum CaseFlagEnum {
  for_first_collect = 'for_first_collect',
  for_review = 'for_review',
  for_recollection = 'for_recollection',
  all_checks_approved = 'all_checks_approved',
}
